import React, { useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Heading,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { Endpoints, joinUrl } from "../../utilities/endpoints";

export const AutenticaLoginForm = () => {
  const [dni, setDni] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(joinUrl(Endpoints.AUTENTICA, "/autentica-login/"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ dni, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      const data = await response.json();

      console.log("Login successful:", data);
      window.location.href = data.next_url; // Redirect to the next URL provided by the backend
    } catch (err) {
      setError("Network error or server unreachable");
      setLoading(false);
    }
  };

  return (
    <Box maxW="400px" mx="auto" mt="50px" p="20px">
      <Heading textAlign="center" mb="20px" size="lg">
        Login
      </Heading>

      <form onSubmit={handleSubmit}>
        <VStack spacing="15px">
          <FormControl isRequired>
            <FormLabel>DNI</FormLabel>
            <Input
              type="text"
              value={dni}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDni(e.target.value)}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            w="100%"
            isLoading={loading}
            loadingText="Logging in..."
          >
            Login
          </Button>
        </VStack>
      </form>

      {error && (
        <Alert status="error" mt="15px" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      )}
    </Box>
  );
};

export default AutenticaLoginForm;
